/**
 * Application class
 * 
 * @author Mautilus s.r.o.
 * @class App 
 * @singleton
 * @mixins Events
 */

App = (function (Events) {

	var App = {
		/**
		 * @property {Boolean} networkStatus Network status, TRUE if connected
		 */
		networkStatus: true,

		/**
		 * @property {Object} reference to current active dialog
		 */
		dialog: null
	};

	$.extend(true, App, Events, {
		/**
		 * @event network
		 * Will be called when network status changes
		 * @param {Boolean} status
		 */

		/**
		 * Initialize Application
		 */
		init: function () {

			////////// helper for promise rejection //////////
			this.initPromiseRejectionHandler();
			Promise.config({
				// Enable warnings
				warnings: false
			});
			//////////////////////////////////////////////////

			var scope = this,
				$notifications = $("#notifications");

			// notification element
			if ($notifications.length) {
				this.$notifications = $notifications;
			} else {
				this.$notifications = $('<div id="notifications" />');
				$("body").append(this.$notifications);
			}

			this.initDebug();

			// throbber timeout
			this.throbberTimeOut = null;
			// is throbber visible
			this.throbberIsShown = false;

			this.sectionsCollection; // Collection of menu and submenu items this variable is set in snippet navigation.js

			// set body class
			var platform = Main.getDevice();
			var deviceLanguage = Device.getLanguage();
			switch (deviceLanguage.substring(0,2)){
				case 'es':
					I18n.changeLanguage('ES');
					$('#scene-signin').addClass('signin_es');
					break;

				case 'ja':
					I18n.changeLanguage('JA');
					$('#scene-signin').addClass('signin_ja');
					break;

				default:
					I18n.changeLanguage('EN');
					$('#scene-signin').addClass('signin_en');
					break;
			}
			$('body').addClass(platform[0] + ' ' + platform.join('-'));

			if (CONFIG.network) {
				// monitor network connection
				window.setInterval(function () {
					scope.checkNetworkConnection();
				}, 1000);

				this.on('network', function (status) {
					console.log('[App] network connection: ' + status);
					this.networkConnectionChange(status);
				}, this);
			}

			this.on('error', function (msg, callback) {
				this.onError(msg, callback);
			}, this);

			this.splashscreen()
				.bind(this)
				.then(function () {
					return this.initProvider();  // Init API
				})
				.then(function() {
					this.initRouter(); 
					return Promise.resolve(); // fake promise continuing for chain
				})
				.then(function () { 
					var userName = Storage.get('userName');
                console.log(userName);
					if(userName) 
						return this.provider.tokenRefresh();
					else 
						return this.provider.freeSignIn();
				})
				.then(function () {
					return this.splashscreenHide();
				})
				.then(function () {
					// Check if logged
					console.log('IS LOGGED? ' + User.isLogged());
					if(User.isLogged()){
						Router.go('home');
					} else {
						Router.go('signin');
					}
					//Router.go('home');
				})
				.catch(function (err) {
					console.error(err);
					if (err !== 'signout') this.trigger('error', err);
				});

			this.initArrows();
		},

		/**
		 * Register scenes
		 * 
		 * @private
		 */
		initRouter: function () {
			Router.addScene('home', new Scene_Home('home'));
			Router.addScene('detail', new Scene_Detail('detail'));
			Router.addScene('signin', new Scene_SignIn('signin'));
			Router.addScene('player', new Scene_Player('player'));
			Router.addScene('search', new Scene_Search('search'));
			Router.addScene('account', new Scene_Account('account'));
		},

		/**
		 * Initialize Promise reject handlers
		 * 
		 * @private
		 * @returns promise
		 */
		initPromiseRejectionHandler: function() {
			var unhandledPromises = [];
			Promise.onPossiblyUnhandledRejection(function (reason, promise) {
				unhandledPromises.push(promise);
				console.log(reason);
				console.log(promise);
				//Update some debugger UI
			});

			Promise.onUnhandledRejectionHandled(function (promise) {
				var index = unhandledPromises.indexOf(promise);
				unhandledPromises.splice(index, 1);
				//Update the debugger UI
			});
		},

		/**
		 * Initialize Provider API
		 * 
		 * @private
		 * @returns promise
		 */
		initProvider: function () {
			return new Promise(function (resolve, reject) {
				var scope = this;

				// set provider's API
				this.provider = API;

				// ProviderAPI ready
				this.provider.on('ready', function () {
					console.log("[App] initProvider done");
					resolve();
				}, this);

				// function for downloading data. It has to be called this way because
				// there has to be checker if data are (or should be) available on USB stick or not
				var download = function (usbPath) {
					// update URL for USB path
					usbPath = usbPath || '';

					// initialize provider API
					// TODO: add provider params
					scope.provider.init({
						'url': usbPath + CONFIG.api.url
					});
				};

				if (ENV == "OFFLINE") {
					Usb.init();

					var nousb = function () {
						// no usb
						console.log('NO USB');

						App.throbberHide();
						var errorDialog = new Snippet_Dialog_error(null, {
							'selector': 'dialog-error'
						});
						errorDialog.onClose = function () {
							Device.exit();
						};
						errorDialog.title = __('usb_error');
						errorDialog.message = __('usb_error_msg');
						errorDialog.render();

						reject();
					};

					// check USB device
					if (!Usb.checkUSB()) {
						nousb();
					} else {
						// usb available
						var usbDevices = Usb.getUSBDevices();
						var usbPath = Usb.getPath(usbDevices);

						console.log("usb path: " + usbPath);
						if (usbPath === null || usbPath == 'null') {
							nousb();
							return;
						}
						download(usbPath);
					}
				} else {
					download();
				}
			}.bind(this));
		},

		/**
		 * @private
		 */
		checkNetworkConnection: function () {
			Device.checkNetworkConnection(function (status) {
				if (status !== this.networkStatus) {
					this.networkStatus = status;
					this.trigger('network', this.networkStatus);
				}
			}, this);
		},

		/**
		 * Network connection change
		 * @param {Boolean} networkStatus - true for connection up, false for connection down
		 */
		networkConnectionChange: function (networkStatus) {
			var d;
			if (App.dialog && typeof App.dialog.networkStatus == 'boolean') {
				// network dialog is opened
				d = App.dialog;
			} else {
				// network dialog is opened
				this.throbberHide();
				d = new Snippet_Dialog_network(null, {
					'selector': 'dialog-network'
				});
			}

			d.networkStatus = networkStatus;
			d.title = '';
			d.message = networkStatus ? __('connection_up') : __('connection_down');
			d.render();

			window.clearTimeout(this.networkDialogTimer);

			if (d.networkStatus) {
				d.focus();
				this.networkDialogTimer = window.setTimeout(function () {
					if (d && typeof d.onClose == 'function') {
						d.onClose();
					}
				}, 5000);
			}
		},


		onError: function (msg, callback) {
            console.log(msg);
            console.log(callback);
			this.throbberHide();
			var errorDialog = new Snippet_Dialog_error(null, {
				'selector': 'dialog-error'
			});
			if (callback !== 'function') {
				errorDialog.onClose = function () {
					//window.location.reload();
                    $('.dialog-error').parent().remove();
                    Router.goBack();
				};
			} else {
				errorDialog.onClose = callback;
			}
			errorDialog.title = __('error');
			errorDialog.message = __(msg || '');
			errorDialog.render();
		},

		/**
		 * Create and display Throbber if it is possible
		 * @param {Boolean} enable set if Controls and Mouse should be enabled or not
		 */
		throbber: function (enable) {
			var scope = this;

			clearTimeout(this.throbberTimeOut);
			this.throbberTimeOut = setTimeout(function () {
				scope.trigger('error', __('err_throbber_timeout'))
			}, CONFIG.appErrTimeout || 180000);
//65000
			if (this.throbberIsShown) {
				return; // only one instance of throbber
			}

			if (!enable) {
				Control.disable(); // while throbber is loading, disable all controls
				Mouse.disable();
			}

			var html = '';
			html += '<div class="throbber ' + ($('#loading').is(':visible') ? 'transparent' : '') + '">';
			html += '<div class="vh">';
			html += '<div class="sk-spinner sk-spinner-wave">';
			html += '<div class="sk-rect1"></div>';
            html += '<div class="sk-rect2"></div>';
            html += '<div class="sk-rect3"></div>';
            html += '<div class="sk-rect4"></div>';
            html += '<div class="sk-rect5"></div>';
			html += '</div>';
			html += '</div>';
			html += '</div>';
			var $throbber = $(html);

			$('body').append($throbber);

			this.throbberIsShown = true;
		},
		/**
		 * Remove and hide Throbber if it is possible
		 * @param {Boolean} disable set if Controls and Mouse should be disabled or not
		 */
		throbberHide: function (disable) {
			if (this.throbberIsShown) {
				this.throbberIsShown = false;
				clearTimeout(this.throbberTimeOut);
				this.throbberTimeOut = null;
				$('.throbber').remove();
				if (!disable) {
					Control.enable();
					Mouse.enable();
				}
			}
		},

		notification: function (msg) {
			var $el = $('<div class="msg" />').html(msg);
			$('#notifications').html($el);

			$el.fadeIn();

			setTimeout(function () {
				if ($el) {
					$el.fadeOut();
				}
			}, 4000);
		},

		/**
		 * Display debug information about app. Enable showing additional information when PIN code (defined in config.js file) is passed
		 */
		initDebug: function () {
			if (typeof ENV != 'undefined' && (ENV == 'DEVELOPMENT' || ENV == 'OFFLINE')) {
				$("body").append('<div id="dev">' + ENV + '<br/>Version:' + CONFIG.version + '<br/>Device: ' + Main.getDevice().join(', ') + '<br/>Firmware: ' + Device.getFirmware() + '</div>');
				var $dev = $('#dev');
				var pinCode = CONFIG.developer.pin.split('');
				Control.on('beforekey', function (keyCode) {
					if (pinCode.length > 0 && Control.getTextValue(keyCode) == pinCode[0]) {
						pinCode.shift();
						if (pinCode.length == 0) {
							if (!$dev[0].isShown) {
								$dev.show();
								$dev[0].isShown = true;
							} else {
								$dev.hide();
								$dev[0].isShown = false;
							}
							pinCode = CONFIG.developer.pin.split('');
						}
					} else {
						pinCode = CONFIG.developer.pin.split('');
					}
				}, this);
			}
		},

		/**
		 * Initialize Mouse arrows (display/hide) 
		 */
		initArrows: function () {
			var scope = this;
			if (CONFIG.mouse.modeArrows === 'off') {
				$('body').addClass('nomouse');
			} else if (CONFIG.mouse.modeArrows === 'on') {
				$('body').removeClass('nomouse');
			} else if (CONFIG.mouse.modeArrows === 'auto') {
				$('body').addClass('nomouse');
				$('body').on('mousemove', function () {
					var $body = $(this);
					window.clearTimeout(scope.arrowsTimeout);
					$body.removeClass('nomouse');

					scope.arrowsTimeout = window.setTimeout(function () {
						$body.addClass('nomouse');
					}, CONFIG.mouse.hideArrows);
				});
			}
		},

		/**
		 * Showing splashscreen
		 * @returns promise. After defined delay (splashscreen should be displayed short time)
		 */
		splashscreen: function () {
			return new Promise(function (resolve) {
				$('#loading').removeClass();
				this.throbber();
				resolve();
			}.bind(this));
		},

		/**
		 * Hide splashscreen
		 * @returns promise. After defined delay (splashscreen should be displayed short time)
		 */
		splashscreenHide: function () {
			return new Promise(function (resolve, reject) {
				// window.setTimeout( function() {
				$('#loading').addClass('animate');

				$('#loading').on('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function (e) {
					$(this).removeClass('animate').addClass('hide');
				});
				resolve();
				// }, 1000 );

			})
		},

		isInSplashScreen: function() {
			var isAnimating = $('#loading').hasClass('animate');
			var isHidden = $('#loading').hasClass('hide');
			return isAnimating || isHidden;
		},

		getVersion: function () {
			return CONFIG.version ? CONFIG.version : '';
		},
	});

	// Initialize this class when Main is ready
	Main.ready(function () {
		App.init();
	});

	return App;

})(Events);



//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 3
// module chunks = 0